import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="timeslot-schedule"
export default class extends Controller {
  static targets = ["links", "template", "duration", "capacity"];

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields";
  }

  add_association(event) {
    event.preventDefault();

    var content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );

    // Insert the new fields before the links target
    this.linksTarget.insertAdjacentHTML("beforebegin", content);

    // Copy duration and capacity from the first existing schedule if available
    // Use setTimeout to ensure DOM is fully updated
    setTimeout(() => {
      this.copyCommonFields();
    }, 10);
  }

  remove_association(event) {
    event.preventDefault();
    const target = event.currentTarget;

    if (
      target.dataset &&
      target.dataset.confirmMessage &&
      !confirm(target.dataset.confirmMessage)
    )
      return;

    let wrapper = target.closest("." + this.wrapperClass);

    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }
  }

  copyCommonFields() {
    // Find the first existing schedule's duration and capacity
    const existingDuration = this.durationTargets.find(
      (input) =>
        input.value && input.closest('[data-new-record="true"]') === null
    );
    const existingCapacity = this.capacityTargets.find(
      (input) =>
        input.value && input.closest('[data-new-record="true"]') === null
    );

    // Copy to the newly added schedule
    if (existingDuration) {
      const newDurationInput = this.durationTargets.find(
        (input) => input.closest('[data-new-record="true"]') !== null
      );
      if (newDurationInput) {
        newDurationInput.value = existingDuration.value;

        // Use a small delay to ensure Stimulus controllers are connected
        setTimeout(() => {
          // Trigger the events that the floating-input controller listens for
          newDurationInput.dispatchEvent(new Event("input", { bubbles: true }));
          newDurationInput.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }, 50);
      }
    }

    if (existingCapacity) {
      const newCapacityInput = this.capacityTargets.find(
        (input) => input.closest('[data-new-record="true"]') !== null
      );
      if (newCapacityInput) {
        newCapacityInput.value = existingCapacity.value;

        // Use a small delay to ensure Stimulus controllers are connected
        setTimeout(() => {
          // Trigger the events that the floating-input controller listens for
          newCapacityInput.dispatchEvent(new Event("input", { bubbles: true }));
          newCapacityInput.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }, 50);
      }
    }
  }

  // Auto-copy duration and capacity when they change
  copyDuration(event) {
    const value = event.target.value;
    console.log("copyDuration called with value:", value);
    if (value) {
      this.durationTargets.forEach((input, index) => {
        const isNewRecord = input.closest('[data-new-record="true"]') !== null;
        console.log(`Duration target ${index}:`, {
          isNewRecord: isNewRecord,
          isSameTarget: input === event.target,
          willUpdate: input !== event.target && !isNewRecord,
        });
        if (input !== event.target && !isNewRecord) {
          input.value = value;
          console.log(`Updated duration target ${index} to:`, value);
        }
      });
    }
  }

  copyCapacity(event) {
    const value = event.target.value;
    console.log("copyCapacity called with value:", value);
    if (value) {
      this.capacityTargets.forEach((input, index) => {
        const isNewRecord = input.closest('[data-new-record="true"]') !== null;
        console.log(`Capacity target ${index}:`, {
          isNewRecord: isNewRecord,
          isSameTarget: input === event.target,
          willUpdate: input !== event.target && !isNewRecord,
        });
        if (input !== event.target && !isNewRecord) {
          input.value = value;
          console.log(`Updated capacity target ${index} to:`, value);
        }
      });
    }
  }
}
